var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "relative" },
    [
      _c(
        "div",
        { ref: "trigger" },
        [_vm._t("default", null, { toggle: _vm.toggleMenu })],
        2
      ),
      _c(
        "BaseTransition",
        { attrs: { duration: 100, animations: "fade scale" } },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.open,
                  expression: "open"
                }
              ],
              ref: "menu",
              staticClass: "absolute mt-2 w-56 rounded-md shadow-lg z-20",
              class: {
                "origin-top-left left-0": _vm.direction === "top-left",
                "origin-top-right right-0": _vm.direction === "top-right"
              }
            },
            [
              _c(
                "div",
                { staticClass: "rounded-md bg-white shadow-xs" },
                _vm._l(_vm.options, function(option, index) {
                  return _c("div", { key: index, staticClass: "py-1" }, [
                    _c(
                      "button",
                      {
                        staticClass:
                          "\n                            flex items-center\n                            block px-4 py-2 text-sm leading-5 text-gray-700 w-full\n                            hover:bg-gray-100 hover:text-gray-900\n                            focus:outline-none focus:bg-gray-100 focus:text-gray-900\n                        ",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.triggerOption(option)
                          }
                        }
                      },
                      [
                        option.icon
                          ? _c("BaseIcon", {
                              staticClass: "w-3 h-3 mr-2",
                              attrs: { name: option.icon }
                            })
                          : _vm._e(),
                        _c("span", [_vm._v(_vm._s(option.text))])
                      ],
                      1
                    )
                  ])
                }),
                0
              )
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }